import { axiosInstanceV2 } from "@src/shared/api";
import { PAYMENTS_API_URL } from "../constants";
import { useAuthStore } from "@src/entities/login/model/store/authStore";

interface createTeamTariffRequestDto {
  company: {
    name: string;
    phone: string;
    email?: string;
    inn?: string;
  };
  package_id: number;
}

export const createTeamTariff = async (data: createTeamTariffRequestDto) => {
  const access_token = useAuthStore.getState().user?.tokens.access_token;
  const response = await axiosInstanceV2.post(
    PAYMENTS_API_URL.createTeamTariff(),
    data,
    {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    },
  );

  return response.data;
};
